import { useEffect, useState } from "react";
import API from "../api";
import { useNavigate } from "react-router-dom";
import { useLoader } from "../context/LoaderContext";

export default function Orders() {
  const [orders, setOrders] = useState([]);
  const [deletedOrders, setDeletedOrders] = useState([]);
  const [closedOrders, setClosedOrders] = useState([]);
  const [olderClosedOrders, setOlderClosedOrders] = useState([]);
  const [form, setForm] = useState({
    product: "",
    shop: "",
    price: "",
  });
  const { showLoader, showSuccess } = useLoader();

  const token = localStorage.getItem("token");
  let payload = null;
  let role = null;
  let self_id = null;
  if (token) {
    try {
      payload = JSON.parse(atob(token.split(".")[1]));
      role = payload.role
      self_id = payload.id
    } catch { }
  }

  const navigate = useNavigate();

  const [monthlyCost, setMonthlyCost] = useState(0);
  const calculateMonthlyCosts = (ordersList) => {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();

    const sum = ordersList.reduce((acc, o) => {
      const price = Number(o.price) || 0;

      if (o.arrived) {
        if (!o.completed_date) return acc; // ha nincs completed_date, kihagyjuk
        const d = new Date(o.completed_date);
        if (d.getFullYear() === year && d.getMonth() === month) {
          return acc + price;
        }
        return acc;
      } else {
        // nincs lezárva: mindig számít
        return acc + price;
      }
    }, 0);

    setMonthlyCost(sum);
  };

  const load = () => {
    API.get("/orders")
      .then((res) => {
        // console.log(res.data)
        setOrders(res.data)
        calculateMonthlyCosts(res.data)
      }
      )
      .catch(() => {
        logout();
      });


    API.get("orders/closed")
      .then((res) => {
        setClosedOrders(res.data)
        // console.log(res.data)
      }
      );


  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const create = async () => {
    if (!form.product) return;
    if (!form.price) form.price = 0;

    showLoader("Hozzáadás...");

    await API.post("/orders", form).then(() => {
      setForm({ product: "", shop: "", price: "" });
      load();
    });

    showSuccess("Sikeresen hozzáadva");
    setTimeout(() => {
      window.location.reload();
    }, 400);
  };

  const logout = () => {
    localStorage.removeItem("token");
    window.location = "/";
  };

  const [showNewOrder, setShowNewOrder] = useState(false);
  const [showDeletedOrders, setShowDeletedOrders] = useState(false);
  const [showOlderOrders, setShowOlderOrders] = useState(false);

  const initialFormState = {
    product: "",
    shop: "",
    price: ""
  };

  const handleAddButton = () => {
    if (showNewOrder) {
      // ha Mégse, ürítjük a formot
      setForm(initialFormState);
    }

    setShowNewOrder(!showNewOrder);
  };

  const handleShowDeletedButton = () => {
    setShowDeletedOrders(!showDeletedOrders)
    if (!showDeletedOrders) {
      // console.log("Load orders")
      API.get("orders/deleted")
        .then((res) => {
          setDeletedOrders(res.data)
          // console.log(res.data)
        }
        );
    }
    else {
      setDeletedOrders([])
    }
  };
  const handleShowOlderButton = () => {
    setShowOlderOrders(!showOlderOrders)
    if (!showOlderOrders) {
      // console.log("Load orders")
      API.get("orders/closed?olderThen=14")
        .then((res) => {
          setOlderClosedOrders(res.data)
          // console.log("Download older orders")
          // console.log(res.data)
        }
        );
    }
    else {
      setOlderClosedOrders([])
    }
  };

  const sortedOrders = orders.sort((b, a) => new Date(a.order_date) - new Date(b.order_date));
  const sortedClosedOrders = closedOrders.sort((b, a) => new Date(a.order_date) - new Date(b.order_date));
  const sortedOlderClosedOrders = olderClosedOrders.sort((b, a) => new Date(a.order_date) - new Date(b.order_date));
  const sortedDeletedOrders = deletedOrders.sort((b, a) => new Date(a.order_date) - new Date(b.order_date));
  const shippingLabels = {
    csomagautomata: "Csomagautomata",
    szemelyes_atvetel: "Személyes átvétel",
    hazhozszallitas: "Házhozszállítás",
    // további értékek...
  };
  const shippingCompany = {
    "gls": "GLS",
    "foxpost": "Foxpost",
    "dpd": "DPD",
    "alza": "Alza",
    "expressone": "Express One",
    "mpl": "MPL",
    "packeta": "Packeta (Z-Box)",
    "sameday": "Sameday"
  }

  const links = {
    "expressone": "https://tracking.expressone.hu/?plc_number=",
    "gls": "https://gls-group.eu/HU/hu/csomagkovetes?match=",
    "dpd": "https://www.dpdgroup.com/hu/mydpd/my-parcels/incoming?parcelNumber=",
    "mpl": "https://www.posta.hu/ugyfelszolgalat/nyomkovetes?ids=",
    "foxpost": "https://foxpost.hu/csomagkovetes/?code=",
    "alza": null,
    "packeta": "https://tracking.packeta.com/hu/",
    "sameday": "https://sameday.hu/#awb="
  }

  const formatPrice = (value) => {
    if (value === null || value === undefined || value === "") return "";
    const n = Number(value);
    if (Number.isNaN(n)) return value;
    return new Intl.NumberFormat('hu-HU', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      useGrouping: true
    }).format(n) + ' Ft';
  };


  return (
    <div className="p-6 max-w-4xl mx-auto">
      {/* Header */}
      <div className="flex justify-between items-center mb-2">
        <h2 className="text-2xl font-bold">Rendeléseid</h2>
        <button
          onClick={handleAddButton}
          className={`text-white rounded px-3 py-1 ml-2 float-right ${showNewOrder ? "bg-red-500" : "bg-blue-500"}`}
          aria-expanded={showNewOrder}
          aria-controls="new-order-panel"
        >
          {showNewOrder ? "Mégse" : "Rendelés felvétele"}
        </button>
      </div>
      <div className="mb-4 text-center">
        <span className="text-m text-gray-400">{formatPrice(monthlyCost)} ebben a hónapban.</span>
      </div>

      {/* Új rendelés (animált) */}
      <div
        id="new-order-panel"
        className={`overflow-hidden transition-all duration-300 ease-in-out transform origin-top ${showNewOrder ? "max-h-[800px] scale-y-100 opacity-100" : "max-h-0 scale-y-95 opacity-0"}`}
        aria-hidden={!showNewOrder}
      >
        <div className="bg-white shadow p-4 rounded mb-6">
          <h3 className="mb-3 font-semibold">Új rendelés adatai</h3>

          <div className={`flex flex-wrap gap-2`}>
            <input
              name="termek"
              placeholder="Termék"
              className="border p-2 rounded"
              onChange={(e) =>
                setForm({ ...form, product: e.target.value })
              }
            />

            <input
              name="webshop"
              placeholder="Webshop"
              className="border p-2 rounded"
              onChange={(e) =>
                setForm({ ...form, shop: e.target.value })
              }
            />

            <input
              name="ar"
              type="number"
              placeholder="Ár"
              min={0}
              className="border p-2 rounded"
              onChange={(e) =>
                setForm({ ...form, price: e.target.value })
              }
            />

            <button
              onClick={create}
              className="bg-green-500 text-white px-4 rounded"
            >
              Hozzáadás
            </button>
          </div>
        </div>
      </div>


      {/* Lista */}
      <div className="bg-white shadow p-4 rounded mb-6"> {/* Aktiv rendelesek */}
        <h3 className="mb-3 font-semibold">Aktív rendelések</h3>

        <div className="space-y-2">
          {sortedOrders.map((o) => (
            <div
              key={o.id}
              className="border rounded p-4 cursor-pointer hover:bg-gray-100 transition flex flex-row"
            >
              {/* kette osztas */}
              <div id="bal" className="w-full" onClick={() => navigate(`/order/${o.id}`)}>
                <div className="font-semibold mb-2 flex flex-col">{role === "admin" && o.secret ? "-- Elrejtve --" : o.product}
                  <span className="text-gray-500 text-xs">{o.order_date.split("T")[0]}</span>
                </div>
                <div className="text-sm text-gray-600 flex flex-col mb-2">
                  <span>
                    {role === "admin" && o.secret ? "-- Elrejtve --" : o.shop}
                    {o.shop && o.price ? " - " : ""}
                    {role === "admin" && o.secret ? "N/A" : formatPrice(o.price)}
                  </span>
                  {(o.shipping_method || o.shipping_company || o.shipment_location) && (
                    <span>
                      {o.shipping_method && shippingLabels[o.shipping_method]}
                      {o.shipping_company ? (
                        <>
                          {` (${shippingCompany[o.shipping_company]}`}
                          {o.shipment_location ? ` - ${o.shipment_location})` : ")"}
                        </>
                      ) : (
                        o.shipment_location && ` (${o.shipment_location})`
                      )}
                    </span>
                  )}
                </div>
                <div className="text-xs mt-1">
                  {o.arrived ? (
                    <span className="text-green-600">
                      ✔ Megérkezett
                    </span>
                  ) : (
                    <span className="text-yellow-600">
                      ⏳ Folyamatban
                    </span>
                  )}
                </div>
                {role === "admin" ? (
                  <>
                    <div className="text-xs text-gray-300 float-right">
                      <span className="uppercase">{o.display_name ? o.display_name : o.username} rendelése</span>
                    </div>
                  </>
                ) : (
                  <></>
                )}
                {self_id === o.contributor_id ? (
                  <>
                    <div className="text-xs text-gray-500 float-right">
                      <span className="uppercase">🔗 ({o.creators_display_name ? o.creators_display_name : o.creators_username})</span>
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </div>
              {o.package_number && links[o.shipping_company] ? (
                <>
                  <div id="jobb" className="float-right w-[36px] content-center">
                    <a href={`${links[o.shipping_company]}${o.package_number}`} target="_blank" rel="noopener noreferrer" className="float-right">
                      <img src="../tracking.png" alt="Nyomkövetés" className="w-[32px]" />
                    </a>
                  </div>
                </>
              ) : (<></>)}
            </div>
          ))}

          {orders.length === 0 && (
            <div className="text-gray-500">
              Nincs aktív rendelésed jelenleg.
            </div>
          )}
        </div>
      </div>

      <div className="bg-white shadow p-4 rounded mb-6"> {/* Lezart rendelesek (default 2 hetnel frisebb) */}
        <h3 className="mb-3 font-semibold">Lezárt rendelések</h3>
        <div className="space-y-2">
          {sortedClosedOrders.map((o) => (
            <div
              key={o.id}
              onClick={() => navigate(`/order/${o.id}`)}
              className="border rounded p-4 cursor-pointer hover:bg-gray-100 transition"
            >
              <div className="font-semibold mb-2 flex flex-col">
                {role === "admin" && o.secret ? "-- Elrejtve --" : o.product}
                <span className="text-xs">
                  <span className="text-gray-400 text-xs line-through">{o.order_date.split("T")[0]} </span>{o.completed_date ? <><span className="text-gray-500 text-xs">{o.completed_date.split("T")[0]}</span></> : ""}
                </span>
              </div>
              <div className="text-sm text-gray-600 flex flex-col mb-2">
                <span>
                  {role === "admin" && o.secret ? "-- Elrejtve --" : o.shop}
                  {o.shop && o.price ? " - " : ""}
                  {role === "admin" && o.secret ? "N/A" : formatPrice(o.price)}
                </span>
                {(o.shipping_method || o.shipping_company || o.shipment_location) && (
                  <span>
                    {o.shipping_method && shippingLabels[o.shipping_method]}
                    {o.shipping_company ? (
                      <>
                        {` (${shippingCompany[o.shipping_company]}`}
                        {o.shipment_location ? ` - ${o.shipment_location})` : ")"}
                      </>
                    ) : (
                      o.shipment_location && ` (${o.shipment_location})`
                    )}
                  </span>
                )}
              </div>
              <div className="text-xs mt-1">
                <span className="text-green-600">
                  ✅ Lezárva
                </span>
              </div>
              {role === "admin" ? (
                <>
                  <div className="text-xs text-gray-300 float-right">
                    <span className="uppercase">{o.display_name ? o.display_name : o.username} rendelése</span>
                  </div>
                </>
              ) : (
                <></>
              )}
              {self_id === o.contributor_id ? (
                <>
                  <div className="text-xs text-gray-500 float-right">
                    <span className="uppercase">🔗 ({o.creators_display_name ? o.creators_display_name : o.creators_username})</span>
                  </div>
                </>
              ) : (
                <></>
              )}
            </div>
          ))}

          {closedOrders.length === 0 && (
            <div className="text-gray-500">
              Nincs lezárt rendelésed még.
            </div>
          )}
        </div>
      </div>

      <div className="bg-white shadow p-4 rounded mb-6"> {/* Lezart rendelesek 2 hetnel regebbi */}
        <h3 className="font-semibold">Lezárt rendelések
          <button
            onClick={handleShowOlderButton}
            className="float-right text-xl w-10 h-10 flex items-center justify-center"
            aria-expanded={showOlderOrders}
            aria-label={showOlderOrders ? "Elrejtés" : "Mutatás"}
          >
            <svg
              className={`w-5 h-5 transition-transform duration-200 ${showOlderOrders ? "transform rotate-180" : ""}`}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>
        </h3>
        <h2 className="mb-3 text-sm">(2 hétnél régebbi) {showOlderOrders ? "" : "(Elrejtve)"}</h2>
        <div className="space-y-2">
          {sortedOlderClosedOrders.map((o) => (
            <div
              key={o.id}
              onClick={() => navigate(`/order/${o.id}`)}
              className="border rounded p-4 cursor-pointer hover:bg-gray-100 transition"
            >
              <div className="font-semibold mb-2 flex flex-col">
                {role === "admin" && o.secret ? "-- Elrejtve --" : o.product}
                <span className="text-xs">
                  <span className="text-gray-400 text-xs line-through">{o.order_date.split("T")[0]} </span>{o.completed_date ? <><span className="text-gray-500 text-xs">{o.completed_date.split("T")[0]}</span></> : ""}
                </span>
              </div>
              <div className="text-sm text-gray-600 flex flex-col mb-2">
                <span>
                  {role === "admin" && o.secret ? "-- Elrejtve --" : o.shop}
                  {o.shop && o.price ? " - " : ""}
                  {role === "admin" && o.secret ? "N/A" : formatPrice(o.price)}
                </span>
                {(o.shipping_method || o.shipping_company || o.shipment_location) && (
                  <span>
                    {o.shipping_method && shippingLabels[o.shipping_method]}
                    {o.shipping_company ? (
                      <>
                        {` (${shippingCompany[o.shipping_company]}`}
                        {o.shipment_location ? ` - ${o.shipment_location})` : ")"}
                      </>
                    ) : (
                      o.shipment_location && ` (${o.shipment_location})`
                    )}
                  </span>
                )}
              </div>
              <div className="text-xs mt-1">
                <span className="text-green-600">
                  ✅ Lezárva
                </span>
              </div>
              {role === "admin" ? (
                <>
                  <div className="text-xs text-gray-300 float-right">
                    <span className="uppercase">{o.display_name ? o.display_name : o.username} rendelése</span>
                  </div>
                </>
              ) : (
                <></>
              )}
              {self_id === o.contributor_id ? (
                <>
                  <div className="text-xs text-gray-500 float-right">
                    <span className="uppercase">🔗 ({o.creators_display_name ? o.creators_display_name : o.creators_username})</span>
                  </div>
                </>
              ) : (
                <></>
              )}
            </div>
          ))}

          {olderClosedOrders.length === 0 && showOlderOrders && (
            <div className="text-gray-500">
              Nincs 2 hétnél korábbi lezárt rendelésed.
            </div>
          )}
        </div>
      </div>

      <div className="bg-white shadow p-4 rounded mb-6"> {/* Torolt rendelesek */}
        <h3 className="font-semibold">Törölt rendelések
          <button
            onClick={handleShowDeletedButton}
            className="float-right text-xl w-10 h-10 flex items-center justify-center"
            aria-expanded={showDeletedOrders}
            aria-label={showDeletedOrders ? "Elrejtés" : "Mutatás"}
          >
            <svg
              className={`w-5 h-5 transition-transform duration-200 ${showDeletedOrders ? "transform rotate-180" : ""}`}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>
        </h3>
        <h2 className="mb-3 text-sm">{showDeletedOrders ? "" : "(Elrejtve)"}</h2>

        <div className="space-y-2">
          {sortedDeletedOrders.map((o) => (
            <div
              key={o.id}
              onClick={() => navigate(`/order/${o.id}`)}
              className="border rounded p-4 cursor-pointer hover:bg-gray-100 transition"
            >
              <div className="font-semibold mb-2 flex flex-col">
                {role === "admin" && o.secret ? "-- Elrejtve --" : o.product}
                <span className="text-xs">
                  <span className="text-gray-400 text-xs line-through">{o.order_date.split("T")[0]} </span>{o.completed_date ? <><span className="text-gray-500 text-xs">{o.completed_date.split("T")[0]}</span></> : ""}
                </span>
              </div>
              <div className="text-sm text-gray-600 flex flex-col mb-2">
                <span>
                  {role === "admin" && o.secret ? "-- Elrejtve --" : o.shop}
                  {o.shop && o.price ? " - " : ""}
                  {role === "admin" && o.secret ? "N/A" : formatPrice(o.price)}
                </span>
                {(o.shipping_method || o.shipping_company || o.shipment_location) && (
                  <span>
                    {o.shipping_method && shippingLabels[o.shipping_method]}
                    {o.shipping_company ? (
                      <>
                        {` (${shippingCompany[o.shipping_company]}`}
                        {o.shipment_location ? ` - ${o.shipment_location})` : ")"}
                      </>
                    ) : (
                      o.shipment_location && ` (${o.shipment_location})`
                    )}
                  </span>
                )}
              </div>
              <div className="text-xs mt-1">
                <span className="text-red-600">
                  ❌ Törölve
                </span>
              </div>
              {role === "admin" ? (
                <>
                  <div className="text-xs text-gray-300 float-right">
                    <span className="uppercase">{o.display_name ? o.display_name : o.username} rendelése</span>
                  </div>
                </>
              ) : (
                <></>
              )}
              {self_id === o.contributor_id ? (
                <>
                  <div className="text-xs text-gray-500 float-right">
                    <span className="uppercase">🔗 ({o.creators_display_name ? o.creators_display_name : o.creators_username})</span>
                  </div>
                </>
              ) : (
                <></>
              )}
            </div>
          ))}

          {showDeletedOrders && deletedOrders.length === 0 && (
            <div className="text-gray-500">
              Nincs törölt rendelésed jelenleg.
            </div>
          )}
        </div>
      </div>
    </div >
  );
}